import React from 'react';
import Button from 'jbc-front/components/Button';
import { BulkDownload, BulkPrint } from 'jbc-front/components/icons';
import CommonModal from 'jbc-front/components/CommonModal';
import styles from './PayReportsDownloadModal.scss';
import { useTranslation } from 'react-i18next';

const PayReportsDownloadModal = props => {
  const { isOpen, hideModal, downloadPdf, downloadZip } = props;
  const { t } = useTranslation();
  const header = t('features.EmployeePays.components.PayReportsDownloadModal.Payslip_batch_export');

  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <React.Fragment>
        <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
        <CommonModal.Body>
          <form>
            <p>{t('features.EmployeePays.components.PayReportsDownloadModal.Please_select_if_you_would_like_to_download_or_print_payslip_in_batch')}</p>
            <div className={styles.button_box}>
              <Button onClick={downloadZip} className={styles.button_frame} data-testid="download-data">
                <BulkDownload size={50} />
                <p>{t('features.EmployeePays.components.PayReportsDownloadModal.Download_data')}</p>
              </Button>
              <Button onClick={downloadPdf} className={styles.button_frame} data-testid="print-data">
                <BulkPrint size={50} />
                <p>{t('features.EmployeePays.components.PayReportsDownloadModal.Print_data')}</p>
              </Button>
            </div>
          </form>
        </CommonModal.Body>
      </React.Fragment>
    </CommonModal>
  );
};

export default PayReportsDownloadModal;
